import { ManageQueuedChanges } from './ManageQueuedChanges'

export const UnqueueChanges = (props) => {
  return <ManageQueuedChanges mode='Unqueue' {...props} />
}
